import PropTypes from 'prop-types';
const SVGComponent =({ fill = '#FAFAFA', ...props })  => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_4029_14411"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={16}
      height={16}
    >
      <rect width={16} height={16} fill={fill} />
    </mask>
    <g mask="url(#mask0_4029_14411)">
      <path
        d="M7 14H2V9H7V14ZM11 14H9V12H11V14ZM14 12V14H12V12H14ZM11 11H9V9H11V11ZM14 11H12V9H14V11ZM7 7H2V2H7V7ZM11 7H9V5H11V7ZM14 7H12V5H14V7ZM11 4H9V2H11V4ZM14 4H12V2H14V4Z"
        fill={fill}
      />
    </g>
  </svg>
);

SVGComponent.propTypes = {
  fill: PropTypes.string,
};

export default SVGComponent;
